<template>
  <div id="games">
    <Title>Interactive Games</Title>
    <SubTitle> <v-icon medium>mdi-ear-hearing</v-icon> Ear Training </SubTitle>
    <div v-if="item < 0">
      <p class="mb-0">Pick a game from the list:</p>

      <v-list
        class="my-4 py-0"
        elevation="2"
        color="#FFFFFFA0"
        max-width="20em"
      >
        <v-list-item-group v-model="item" color="primary">
          <template v-for="(item, i) in items">
            <v-divider v-if="i > 0" :key="'d' + i"></v-divider>
            <v-list-item :key="'li' + i">
              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
                <v-list-item-subtitle
                  v-text="item.subtitle"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
    </div>
    <div v-else>
      <v-btn title outlined @click="item = -1">Switch game</v-btn>
    </div>

    <div class="mt-4">
      <IntervalGame v-if="item == 0" />
      <TriadGame v-if="item == 1" />
      <QuatriadGame v-if="item == 2" />
    </div>
  </div>
</template>

<script>
import IntervalGame from "@/components/IntervalGame.vue";
import TriadGame from "@/components/TriadGame.vue";
import QuatriadGame from "@/components/QuatriadGame.vue";

export default {
  name: "GamesPage",
  components: { IntervalGame, TriadGame, QuatriadGame },
  data: () => ({
    item: -1,
    items: [
      { title: "Intervals", subtitle: "Learn to recognise groups of 2 notes" },
      { title: "Triads", subtitle: "Learn to identify 3-note chords" },
      { title: "Quatriads", subtitle: "Learn to identify 4-note chords" }
    ]
  })
};
</script>
